import { IAuditFormData } from "../interfaces/IAudit";
import IFormDefinition from "../interfaces/IFormDefinition";
import { IFormSchema } from "../interfaces/IFormSchema";
import { forEachSchemaProp } from "./schema.helpers";
import _selectn from "selectn";
import { TSubmittableObservation } from "../interfaces/IObservation";
import { JSONSchemaDefinition } from "../../sg-schema/RJSF";


export const ControlledObservationFormFields = {
    informer: "ilmottaja",
    target: "sijainti",
    eventTime: "tapahtuma_aika",

    title: "otsikko",
    details: "kuvaus",
    images: "kuvat",
    image: "kuva"
};

const makeRemoveRule = (field: string) => ({
    conditions: {},
    event: {
        type: "remove",
        params: {
            field: [field]
        }
    }
});

export const transformObservationSchema = (schemas: IFormDefinition["schema"]): IFormDefinition["schema"] => {
    const { schema: { properties = {} }, rules = [] } = schemas;

    const removeTopLeveFields = [
        ControlledObservationFormFields.informer,
        //  ControlledObservationFormFields.eventTime
    ];

    removeTopLeveFields.forEach((key) => {
        properties[key] && rules.push(makeRemoveRule(key));
    });


    if (!schemas.uiSchema["ui:order"]) {
        const order = ["otsikko", "kuvaus", "kuvat", "*"]
        schemas.uiSchema["ui:order"] = order;
    };

    return ({
        ...schemas,
        rules
    })
};


const extractSubmittableObservations = (value: IAuditFormData[any], prop: JSONSchemaDefinition, path: string) => {
    let items: any[] = [];

    if (!prop || typeof prop === "boolean" || typeof prop.type !== "string") {
        return items;
    }

    items = !value ? [] : Array.isArray(value) ? value : typeof value === "object" ? [value] : [];


    let observations: Array<TSubmittableObservation> = items.map((data, index) => ({ path: prop.type === "array" ? `${path}[${index}]` : path, data }))
    observations = observations.filter((entry) => entry.data.safetyObservation);

    return observations;
};


export const getSafetyObservations = (formData: IAuditFormData, formSchema: IFormSchema) => {
    const { uiSchema } = formSchema;
    let observations: Array<TSubmittableObservation> = []
    if (!formSchema.schema.properties) {
        return observations
    }
    forEachSchemaProp(formSchema.schema.properties, (path, prop) => {
        const uiProp = _selectn(path, uiSchema) || {};
        const value = _selectn(path, formData);

        const observationOptions = uiProp["ui:safetyObservation"];
        if (observationOptions && observationOptions.formReference) {
            observations = extractSubmittableObservations(value, prop, path);
        };

    })
    return observations;


}
